import { ERROR } from '../constants/drawer'
import { _fetchTokenConfig } from '../mfcLogic/api/tokens'
import { ModalKind, setModal } from '../state/modals'
import { AppRouter } from '../state/state.router'
import { inChatQuickBuyDialog } from './inChatQuickBuyDialog'

interface OpenErrorProps {
    message?: string
}

export const openError = (props: OpenErrorProps = {}) => {
    // const id = ERROR
    // this is only really used for Errors now
    const { message } = props
    // const { query: { slug } = {}, asPath } = Router
    // const [, page] = asPath.toLowerCase().split('/')
    const page = AppRouter.route.visiblePage
    const slug = AppRouter.route.slug

    const isRoomPage = page === 'room'
    const isMessagePage = page === 'message'
    if (
        message?.includes('Tip exceeds tokens available') &&
        (isRoomPage || isMessagePage) &&
        slug
    ) {
        setModal(ModalKind.Drawer, ERROR, props, true)
        _fetchTokenConfig().then((config) => {
            inChatQuickBuyDialog({
                ...config,
                location: {
                    type: page,
                    slug: slug.toString(),
                },
            })
        })
        return
    }
    setModal(ModalKind.Drawer, ERROR, props, true)
}
